document.addEventListener("DOMContentLoaded", function() {

  // 1. Variables
  let activeMode = 'one-time';
  let slideIndex = 0;
  let slideInterval;
  let resumeTimeout;
  const SLIDE_DURATION = 3500;
  const PAUSE_DURATION = 6000;

  // 2. Selectors
  const deliveryInterval = document.getElementById('deliveryInterval');
  const imageModal       = document.getElementById('imageModal');
  const mainImg          = document.getElementById('MainProductImg');
  const closeModalBtn    = document.getElementById('CloseModalBtn');
  const optRadios        = document.querySelectorAll('input[name="purchase-type"]');
  const qtyBtns          = document.querySelectorAll('.qty-btn');
  const addToCartBtn     = document.getElementById('AddToCartBtn');
  const thumbs           = document.querySelectorAll('.thumb-item');
  const accordions       = document.querySelectorAll('.acc-detail-item');
  const productForm      = document.getElementById('femi-product-form');

  // 3. Init
  if (deliveryInterval) updateSubscriptionPrice();
  syncFormInputs();

  // 4. Event Listeners
  if (mainImg) mainImg.addEventListener('click', openModal);

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      setManualImage(parseInt(this.dataset.index));
    });
  });

  if (closeModalBtn) closeModalBtn.addEventListener('click', closeModal);
  if (imageModal) {
    imageModal.addEventListener('click', function(e) {
      if (e.target === this) closeModal();
    });
  }

  accordions.forEach(acc => {
    acc.querySelector('summary').addEventListener('click', function() {
      accordions.forEach(other => { if (other !== acc) other.removeAttribute('open'); });
    });
  });

  if (deliveryInterval) {
    deliveryInterval.addEventListener('change', function() {
      updateSubscriptionPrice();
      syncFormInputs();
    });
  }

  optRadios.forEach(radio => {
    radio.addEventListener('change', function() { toggleFrequency(this.value); });
  });

  qtyBtns.forEach(btn => {
    btn.addEventListener('click', function() { adjustQty(parseInt(this.dataset.val)); });
  });

  // ── Form Submit Handler ──
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      syncFormInputs();

      // BUY NOW — let native submit pass through to Razorpay
      if (e.submitter && e.submitter.name === 'checkout') return;

      // ADD TO CART — intercept and use AJAX
      e.preventDefault();
      doAddToCart();
    });
  }

  // 5. Functions
  function syncFormInputs() {
    const variantInput = document.getElementById('FinalVariantId');
    const qtyInput     = document.getElementById('FinalQtyHidden');
    const qtyDisplay   = document.getElementById('FinalQty');
    const onetimeHidden = document.getElementById('femi-onetime-id');
    if (!variantInput) return;

    if (!deliveryInterval || activeMode === 'one-time') {
      variantInput.value = onetimeHidden ? onetimeHidden.value : variantInput.value;
    } else {
      variantInput.value = deliveryInterval.value;
    }
    if (qtyInput && qtyDisplay) qtyInput.value = parseInt(qtyDisplay.value) || 1;
  }

  function updateSubscriptionPrice() {
    if (!deliveryInterval) return;
    const sel = deliveryInterval.options[deliveryInterval.selectedIndex];
    document.getElementById('SubPriceDisplay').textContent = "Rs. " + parseFloat(sel.getAttribute('data-price')).toLocaleString('en-IN') + ".00";
    document.getElementById('OldPriceDisplay').textContent = "Rs. " + parseFloat(sel.getAttribute('data-old-price')).toLocaleString('en-IN') + ".00";
  }

  function toggleFrequency(type) {
    activeMode = type;
    document.getElementById('labelOneTime').classList.toggle('active', type === 'one-time');
    document.getElementById('labelSubscribe').classList.toggle('active', type === 'subscribe');
    syncFormInputs();
  }

  function adjustQty(val) {
    const input = document.getElementById('FinalQty');
    const newVal = parseInt(input.value) + val;
    if (newVal >= 1) { input.value = newVal; syncFormInputs(); }
  }

  function openModal() {
    imageModal.style.display = "block";
    const expandedImg = document.getElementById("img01");
    expandedImg.src = mainImg.src;
    expandedImg.alt = mainImg.alt; // A11Y FIX: Transfer alt text for screen readers
  }

  function closeModal() {
    imageModal.style.display = "none";
  }

  function updateMainDisplay(index) {
    if (!thumbs[index]) return;
    mainImg.style.opacity = '0.7';
    setTimeout(() => { mainImg.src = thumbs[index].dataset.fullsrc; mainImg.style.opacity = '1'; }, 150);
    thumbs.forEach(t => t.classList.remove('active-thumb'));
    thumbs[index].classList.add('active-thumb');
    const strip = document.getElementById('ThumbStrip');
    strip.scrollTo({ left: thumbs[index].offsetLeft - (strip.clientWidth / 2) + (thumbs[index].clientWidth / 2), behavior: 'smooth' });
  }

  function nextImage() {
    if (thumbs.length === 0) return;
    slideIndex = (slideIndex + 1) % thumbs.length;
    updateMainDisplay(slideIndex);
  }

  function startSlideshow() {
    if (window.innerWidth <= 768) return;
    clearInterval(slideInterval);
    slideInterval = setInterval(nextImage, SLIDE_DURATION);
  }

  function setManualImage(index) {
    clearInterval(slideInterval);
    clearTimeout(resumeTimeout);
    slideIndex = index;
    updateMainDisplay(index);
    if (window.innerWidth > 768) resumeTimeout = setTimeout(startSlideshow, PAUSE_DURATION);
  }

  let slideshowStarted = false;
  function initSlideshowOnInteraction() {
    if (!slideshowStarted) {
      slideshowStarted = true;
      if (window.innerWidth > 768) startSlideshow();
      document.removeEventListener('scroll', initSlideshowOnInteraction);
      document.removeEventListener('touchstart', initSlideshowOnInteraction);
    }
  }
  document.addEventListener('scroll', initSlideshowOnInteraction, { passive: true });
  document.addEventListener('touchstart', initSlideshowOnInteraction, { passive: true });
  window.addEventListener('pagehide', () => { clearInterval(slideInterval); clearTimeout(resumeTimeout); });

  // ── Cart Functions ──

  function doAddToCart() {
    const variantId  = parseInt(document.getElementById('FinalVariantId').value);
    const qty        = parseInt(document.getElementById('FinalQty').value) || 1;
    const properties = {};

    if (activeMode === 'subscribe' && deliveryInterval) {
      const sel = deliveryInterval.options[deliveryInterval.selectedIndex];
      const oldPrice = sel.getAttribute('data-old-price');
      if (oldPrice && oldPrice !== "0") properties['_market_price'] = oldPrice;
    }

    // Instantly open the drawer for snappy UX
    if (typeof window.openCart === 'function') window.openCart();

    addToCartBtn.textContent   = "Adding...";
    addToCartBtn.style.opacity = "0.7";
    addToCartBtn.style.pointerEvents = "none";

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties }] })
    })
    .then(res => { 
      if (!res.ok) throw new Error('Failed to add to cart'); 
      return res.json(); 
    })
    .then((cartData) => {
      // ARCHITECTURE FIX: Dispatch event to trigger the Drawer & Header Bubble to update themselves
      window.dispatchEvent(new CustomEvent('cart:added', { detail: cartData }));
      
      addToCartBtn.textContent   = "ADD TO CART";
      addToCartBtn.style.opacity = "1";
      addToCartBtn.style.pointerEvents = "auto";
    })
    .catch(err => {
      addToCartBtn.textContent   = "ADD TO CART";
      addToCartBtn.style.opacity = "1";
      addToCartBtn.style.pointerEvents = "auto";
      console.error(err);
    });
  }

});